import { ChevronLeft, ArchiveRestore } from 'lucide-react';
import styles from './EntityForm.module.css';
import ArchiveButton from '../ArchiveButton/ArchiveButton';

export default function EntityForm({
  title,
  onCancel,
  onSubmit,
  submitLabel,
  isSubmitting,
  error,
  children,
  canDelete,
  onDelete,
  confirmMessage,
  canRestore,
  onRestore,
  restoreLabel,
  belowCard,
  canCancelBooking,
  onCancelBooking,
  cancelBookingConfirmMessage,
  isCancellingBooking,
}) {
  return (
    <div className={styles.page}>
      {/* Page header */}
      <div className={styles.pageHeader}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={onCancel}
          aria-label="Go back"
        >
          <ChevronLeft size={18} strokeWidth={1.5} />
        </button>
        <h1 className={styles.pageTitle}>{title}</h1>
      </div>

      {/* Top-level error banner */}
      {error && (
        <div className={styles.errorBanner} role="alert">
          {error}
        </div>
      )}

      {/* Card */}
      <div className={styles.card}>
        {/* Form body */}
        <form className={styles.formBody} onSubmit={onSubmit} noValidate>
          <div className={styles.fieldArea}>{children}</div>

          {/* Sticky card footer */}
          <div className={styles.cardFooter}>
            {/* Archive / danger action on left */}
            <div className={styles.footerLeft}>
              {canDelete && onDelete && (
                <ArchiveButton
                  confirmMessage={confirmMessage}
                  onConfirm={onDelete}
                  disabled={isSubmitting}
                />
              )}
              {canRestore && onRestore && (
                <button
                  type="button"
                  className={styles.restoreBtn}
                  onClick={onRestore}
                  disabled={isSubmitting}
                >
                  <ArchiveRestore size={14} strokeWidth={1.5} />
                  {restoreLabel || 'Restore'}
                </button>
              )}
              {canCancelBooking && onCancelBooking && (
                <button
                  type="button"
                  className={styles.cancelBookingBtn}
                  onClick={() => {
                    if (!window.confirm(cancelBookingConfirmMessage || 'Are you sure you want to cancel this booking? This cannot be undone.')) return;
                    onCancelBooking();
                  }}
                  disabled={isSubmitting || isCancellingBooking}
                >
                  {isCancellingBooking ? 'Cancelling…' : 'Cancel booking'}
                </button>
              )}
            </div>

            {/* Cancel + Submit on right */}
            <div className={styles.footerRight}>
              <button
                type="button"
                className={styles.cancelBtn}
                onClick={onCancel}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={styles.submitBtn}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Saving…' : (submitLabel || 'Save')}
              </button>
            </div>
          </div>
        </form>
      </div>

      {belowCard}
    </div>
  );
}
